
const FeeNegotiation = () => {
  return (
    <section>
      <div className="fw-semibold fs-5 my-3">Fee Negotiation and Discounts</div>

      <div className="p-2 bg-white">
        <div className="p-3 border border-subtle-secondary">
          <div>High-volume sellers may qualify for discounted rates. Contact support for details.</div>

          <div>Contact Support:</div>
        </div>
      </div>
    </section>
  )
}

export default FeeNegotiation
